import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';

import { getValue, toTitle } from '_utils';

import {
  SUBLICENSE_DISPLAY_NAMES,
  SUBLICENSE_OPTIONS_BY_MAX_VERSION,
  AC_TYPES,
  SUBLICENSE_IDS
} from "../../server/constants";

import { Form, Button } from 'semantic-ui-react';

import BaseNumberField from '_forms/baseNumber';
import BaseInputField from '_forms/baseInput';
import BaseCheckboxField from '_forms/baseCheckbox';
import BaseCheckboxGroupField from '_forms/baseCheckboxGroup';
import BaseDateField from '_forms/baseDate';
import AcSourceField from '_forms/source';
import AcTypeField from '_forms/acType';

const AC_SOURCES = [7, 8, 9].map(v => ({ text: toTitle(`max${v}`), value: `max${v}` }));

const ResellerBatchACForm = ({ data, onChange, onSubmit }) => {

  const onFieldChange = (e, field) => onChange(field.name, getValue(field));

  const addOnOptions = SUBLICENSE_OPTIONS_BY_MAX_VERSION[data.source].map(id => ({
    label: SUBLICENSE_DISPLAY_NAMES[id],
    value: id
  }));

  return (
    <Form size='tiny' onSubmit={ onSubmit } >
      <Form.Group>
        <AcSourceField
          width={5}
          name='source'
          value={ data.source }
          options={ AC_SOURCES }
          onChange={ onFieldChange }
        />
        <BaseNumberField
          width={5}
          name='count'
          min={1}
          value={ data.count }
          onChange={ onFieldChange }
          labelTxt='Number of Codes'
          popupTxt='We can create ACs in batches. How many of this type of AC license would you like to create?'
        />
        <BaseCheckboxField
          width={2}
          name='upgrade'
          checked={ data.upgrade }
          onChange={ onFieldChange }
          labelTxt='Upgrade'
          popupTxt='Is this AC license for an upgrade purchase? If so, check this box and the end user will be required to either own an upgradable version of Max or submit a Serial Number from a prior Max version.'
        />
      </Form.Group>
      <Form.Group>
        <AcTypeField
          width={5}
          name='type'
          value={ data.type }
          onChange={ onFieldChange }
        />
        {
          data.type === AC_TYPES.TERM_DAYS ? (
            <BaseNumberField
              width={ 5 }
              name='expires_days_after_init'
              min={ 1 }
              max={ 365 } // max one year
              value={ data.expires_days_after_init }
              onChange={ onFieldChange }
              labelTxt='Expire set days after activation'
              popupTxt='The end user will get this many number of days to use Max, starting when they activate.'
            />
          ) : null
        }
        {
          data.type === AC_TYPES.TERM_DATE ? (
            <BaseDateField
              width={ 5 }
              name='expires_on'
              value={ data.expires_on }
              onChange={ onFieldChange }
              maxDate={ moment().add(2, 'years') }
              minDate={ moment().add(1, 'days') }
              labelTxt='Expires On'
              popupTxt='Set a fixed expiration date.'
            />
          ) : null
        }
      </Form.Group>
      <Form.Group>
        <BaseCheckboxGroupField
          name="addons"
          labelTxt={ addOnOptions.length ? 'Included Add Ons' : `No addons available for ${toTitle(data.source)}` }
          popupTxt="Include the following add ons for all of the Activation Code licenses that will be created with this batch."
          onChange={ onFieldChange }
          options={ addOnOptions }
          value={ data.addons }
        />
      </Form.Group>
      <Form.Group>
        <BaseInputField width={16} name='description'
          type='text'
          value={ data.description }
          onChange={ onFieldChange }
          labelTxt='Description (optional)'
          popupTxt='Set a note for your reference.'
        />
      </Form.Group>
      <Button.Group>
        <Button positive type="submit">Create Codes</Button>
      </Button.Group>
    </Form>
  );
};

ResellerBatchACForm.propTypes = {
  data: PropTypes.shape({
    addons: PropTypes.arrayOf(PropTypes.oneOf(Object.values(SUBLICENSE_IDS))).isRequired,
    count: PropTypes.number.isRequired,
    source: PropTypes.oneOf(Object.values(AC_SOURCES).map(s => s.value)).isRequired,
    type: PropTypes.oneOf(Object.values(AC_TYPES)).isRequired,
    upgrade: PropTypes.bool.isRequired,
    description: PropTypes.string.isRequired,

    expires_on: PropTypes.oneOfType([
      PropTypes.instanceOf(Date),
      PropTypes.instanceOf(moment),
      PropTypes.string
    ]),
    expires_days_after_init: PropTypes.number

  }).isRequired,
  onSubmit: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  reseller: PropTypes.object.isRequired,
}

export default ResellerBatchACForm;



// WEBPACK FOOTER //
// ./webAdmin/forms/acBatchReseller.js